/* Shared bundle picker v3.5
   Single / Duo / Trio+ cards. Each tee row can be any eligible design
   ("Change design" opens a picker with search, filters and matching designs).
   Cart roles (_fl_role full / additional) are set here and kept right by fl-cart.js.
   v3.8: tapping a design image opens a larger view (bundle rows and the picker).
   v4.0: "Size guide" link on tee #1 opens the size table (from the page's Size guide accordion) in a sheet.
   v3.9: Single is the default; every tee row has a trash button (any tier, down to 1 tee).
         Removing a tee steps the tier down (Trio+ 3 -> Duo -> Single) and keeps the
         remaining picks exactly as chosen; Single keeps tee #1 as chosen and can change design. */
(function () {
  var box = document.querySelector('.fl-b[data-fl]');
  if (!box || box.__fl) return;
  box.__fl = true;
  var noun = box.dataset.wqNoun || 'tee';
  var nounPlural = box.dataset.wqNounPlural || 'tees';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var swapLabel = box.dataset.flBundleSwapLabel || 'Change design';
  var hint = box.dataset.flBundleHint === undefined ? 'Pick another design—or keep this one.' : box.dataset.flBundleHint;
  var PRICING = window.WQBundle;
  var VENDOR = window.FL_VENDOR;
  var MAXROWS = 10;
  var HEX = { Pepper: '#555552', Black: '#252525', Berry: '#78435E', Moss: '#686E50', Espresso: '#554239', Ivory: '#E9DCC4', White: '#FFFFFF' };
  var GENERIC = { gift: 1, holiday: 1, trending: 1, everyday: 1 };
  var CHIPS = ['Christmas', 'Hunting', 'Western', 'Funny', 'Thanksgiving', 'Dog Lovers', 'Christian', 'Birds'];
  var TRASH_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';
  var RULER_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.2"/><path d="M6.5 8v3M10 8v4.5M13.5 8v3M17 8v4.5"/></svg>';
  var ZOOM_SVG = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';

  /* ---------- product data ---------- */
  function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
  function prep(p) {
    var names = optNames(p);
    p._ci = names.indexOf('Color');
    p._si = names.indexOf('Size');
    p._colors = []; p._sizes = [];
    p.variants.forEach(function (v) {
      var c = v.options[p._ci], s = v.options[p._si];
      if (p._colors.indexOf(c) < 0) p._colors.push(c);
      if (p._sizes.indexOf(s) < 0) p._sizes.push(s);
    });
    p._base = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
    return p;
  }
  var CUR = prep(JSON.parse(document.getElementById('fl-p-' + box.dataset.fl).textContent));
  if (CUR._ci < 0 || CUR._si < 0) return;
  var cache = {}; cache[CUR.handle] = CUR;

  function loadProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { cache[handle] = prep(p); return cache[handle]; });
  }
  var list = null;
  function loadList() {
    if (list) return Promise.resolve(list);
    return fetch(ROOT + 'collections/all/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        list = (j.products || []).filter(function (p) {
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          return p.vendor === VENDOR && tags.indexOf('hidden') < 0 && p.variants && p.variants.length > 1;
        });
        // Keep the current design selectable when its direct-link product is unlisted.
        if (!list.some(function (p) { return p.handle === CUR.handle; })) {
          var currentCard = JSON.parse(JSON.stringify(CUR));
          currentCard.variants.forEach(function (v) { v.price = (v.price / 100).toFixed(2); });
          list.unshift(currentCard);
        }
        return list;
      });
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(x) { return '$' + (x / 100).toFixed(2); }
  function img(u, w) {
    if (!u) return '';
    if (typeof u === 'object') u = u.src || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function find(p, c, s) { return p.variants.find(function (v) { return v.options[p._ci] === c && v.options[p._si] === s; }); }
  function anyOfColor(p, c) { return p.variants.find(function (v) { return v.options[p._ci] === c; }); }
  function rowImg(row) {
    var v = anyOfColor(row.p, row.c);
    return img((v && v.featured_image) || row.p.featured_image || row.p.image, 120);
  }
  function thumbBtn(row, i) {
    return '<button type="button" class="fl-b-zoom" data-zoom="' + i + '" aria-label="View ' + esc(row.p.title) + ' larger">' +
      '<img class="fl-b-thumb" src="' + esc(rowImg(row)) + '" alt="" width="52" height="52" loading="lazy">' +
      '<span class="fl-zm-ic" aria-hidden="true">' + ZOOM_SVG + '</span></button>';
  }

  /* ---------- state ---------- */
  function startColor() {
    var id = new URLSearchParams(location.search).get('variant');
    var v = CUR.variants.find(function (x) { return String(x.id) === String(id); });
    return v ? v.options[CUR._ci] : CUR._colors[0];
  }
  var c0 = startColor();
  function fresh() { return { p: CUR, c: c0, s: '' }; }
  var sel = []; for (var j = 0; j < MAXROWS; j++) sel.push(fresh());
  var n = 1, r = 3, tried = false, ready = false;

  /* Keep the shopper's picks when they come back (Back from checkout, reload). */
  var SKEY = 'fl-b-' + CUR.id;
  function save() {
    if (!ready) return;
    try {
      sessionStorage.setItem(SKEY, JSON.stringify({ n: n, r: r, rows: sel.map(function (x) { return { h: x.p.handle, c: x.c, s: x.s }; }) }));
    } catch (e) {}
  }
  function navType() {
    try { var e = performance.getEntriesByType('navigation')[0]; return e ? e.type : ''; } catch (e) { return ''; }
  }
  var saved = null, unlocked = false;
  if (navType() === 'back_forward' || navType() === 'reload') {
    try { saved = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (e) { saved = null; }
  }
  function restore() {
    if (!saved || !saved.rows) return Promise.resolve(false);
    if (saved.n === 1 || saved.n === 2 || saved.n === 3) n = saved.n;
    if (saved.r >= 3 && saved.r <= MAXROWS) r = saved.r;
    return Promise.all(saved.rows.slice(0, MAXROWS).map(function (x, i) {
      if (!x || !x.h) return null;
      return loadProduct(x.h).then(function (p) {
        if (unlocked || p._ci < 0 || p._si < 0) return;
        sel[i] = { p: p, c: p._colors.indexOf(x.c) > -1 ? x.c : p._colors[0], s: p._sizes.indexOf(x.s) > -1 ? x.s : '' };
      }).catch(function () {});
    })).then(function () { return true; });
  }

  function rows(k) { return k === 3 ? r : k; }
  function calc(k, memberPricing) {
    var prices = [], t = rows(k);
    for (var i = 0; i < t; i++) {
      var row = sel[i], v = row.s ? find(row.p, row.c, row.s) : null;
      prices.push(v ? v.price : row.p._base);
    }
    return PRICING.quote(prices, memberPricing === undefined ? PRICING.member() : memberPricing);
  }

  /* ---------- size guide (v4.0) ---------- */
  /* Reuses the table in the page's "Size guide" accordion so there is one source of truth. */
  var SG = (function () {
    var d = Array.prototype.find.call(document.querySelectorAll('.fl-acc details'), function (x) {
      var s = x.querySelector('summary'); return s && /size guide/i.test(s.textContent);
    });
    var b = (d && d.querySelector('.fl-acc-body')) || document.querySelector('[data-size-dialog] .rte');
    return b && b.textContent.trim() ? b.innerHTML : '';
  })();
  var sg = null, sgFocus = null;
  function sgOpen() { return !!(sg && sg.classList.contains('is-open')); }
  function openSizeGuide() {
    if (!SG) return;
    if (!sg) {
      sg = document.createElement('div');
      sg.className = 'fl-sg';
      sg.setAttribute('role', 'dialog'); sg.setAttribute('aria-modal', 'true'); sg.setAttribute('aria-label', 'Size guide');
      sg.innerHTML = '<div class="fl-sg-panel"><div class="fl-sg-hd"><p class="fl-sg-h">Size guide</p>' +
        '<button type="button" class="fl-sg-x" aria-label="Close">×</button></div><div class="fl-sg-body fl-acc">' + SG + '</div></div>';
      document.body.appendChild(sg);
      sg.addEventListener('click', function (e) { if (e.target === sg || e.target.closest('.fl-sg-x')) closeSizeGuide(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sgOpen()) { e.stopPropagation(); closeSizeGuide(); } }, true);
    }
    sgFocus = document.activeElement;
    sg.classList.add('is-open'); document.documentElement.classList.add('fl-pk-lock');
    setTimeout(function () { var x = sg.querySelector('.fl-sg-x'); if (x) x.focus(); }, 30);
    try {
      var sgEvent = Shopify.analytics.publish('fl_size_guide_open', { product_id: sel[0].p.id });
      if (sgEvent && sgEvent.catch) sgEvent.catch(function () {});
    } catch (e) {}
  }
  function closeSizeGuide() {
    if (!sg) return;
    sg.classList.remove('is-open');
    if (!pickerOpen() && !zoomOpen()) document.documentElement.classList.remove('fl-pk-lock');
    if (sgFocus && sgFocus.focus) sgFocus.focus();
  }

  /* ---------- rendering ---------- */
  var cards = box.querySelectorAll('.fl-b-card'), btn = box.querySelector('.fl-add');

  function sizeSelect(row, i) {
    return '<label class="fl-dd fl-dd--size' + (tried && !row.s ? ' fl-err' : '') + '"><span class="fl-vh">Size</span>' +
      '<select autocomplete="off" data-size="' + i + '"><option value=""' + (row.s ? '' : ' selected') + ' disabled>Size</option>' +
      row.p._sizes.map(function (s) { return '<option' + (s === row.s ? ' selected' : '') + '>' + esc(s) + '</option>'; }).join('') +
      '</select>' + (tried && !row.s ? '<span class="wq-bundle-size-error" role="alert">Please select a size</span>' : '') + '</label>';
  }
  function colorSelect(row, i) {
    return '<label class="fl-dd fl-dd--color"><span class="fl-vh">Color</span><i class="fl-dot" style="background:' + (HEX[row.c] || '#ccc') + '"></i>' +
      '<select autocomplete="off" data-color="' + i + '">' +
      row.p._colors.map(function (c) { return '<option' + (c === row.c ? ' selected' : '') + '>' + esc(c) + '</option>'; }).join('') +
      '</select></label>';
  }
  /* One row per tee. Single keeps tee #1 exactly as chosen (never silently reset to this page's product). */
  function rowHtml(i, k, t) {
    var row = sel[i], multi = k !== 1, lbl = multi ? ' for tee ' + (i + 1) : '';
    return '<div class="fl-b-row fl-b-row--m" data-i="' + i + '">' +
      thumbBtn(row, i) +
      '<div class="fl-b-main"><div class="fl-b-rowhd">' + (multi ? '<span class="fl-b-idx">#' + (i + 1) + '</span>' : '') +
      '<span class="fl-b-title" data-swap="' + i + '" role="button" tabindex="0" aria-label="Change design' + lbl + '">' + esc(row.p.title) + '</span></div>' +
      '<div class="fl-b-act"><button type="button" class="fl-swap" data-swap="' + i + '" aria-label="Change design' + lbl + '"><span class="fl-swap-ic" aria-hidden="true">↻</span> ' + esc(swapLabel) + '</button>' +
      (i >= 1 && hint ? '<span class="fl-b-hint">' + esc(hint) + '</span>' : '') +
      (i === 0 && SG ? '<button type="button" class="fl-sg-link" data-sg aria-haspopup="dialog">' + RULER_SVG + 'Size guide</button>' : '') + '</div>' +
      '<div class="fl-b-ctrl">' + colorSelect(row, i) + sizeSelect(row, i) +
      (t > 1 ? '<button type="button" class="fl-rm" data-rm="' + i + '" aria-label="Remove tee ' + (i + 1) + '">' + TRASH_SVG + '</button>' : '') +
      '</div></div></div>';
  }
  function rowsHtml(k) {
    var h = '', t = rows(k);
    for (var i = 0; i < t; i++) h += rowHtml(i, k, t);
    if (k === 3 && t < MAXROWS) h += '<button type="button" class="fl-more">+ Add another tee</button>';
    return h;
  }
  /* Remove one tee and step the tier down so the price always matches the tees shown. */
  function removeRow(i) {
    var t = rows(n); if (t <= 1 || i < 0 || i >= t) return;
    var gone = sel[i];
    sel.splice(i, 1); sel.push(fresh());
    if (n === 3 && r > 3) r--;
    else if (n === 3) n = 2;
    else if (n === 2) n = 1;
    if (i === 0 && sel[0].p === CUR) syncGallery(sel[0].c);
    try {
      var rmEvent = Shopify.analytics.publish('fl_bundle_tee_removed', { tee: i + 1, product_id: gone.p.id, tees_left: rows(n) });
      if (rmEvent && rmEvent.catch) rmEvent.catch(function () {});
    } catch (e) {}
    render();
  }
  function render() {
    box.dataset.selectedSize = sel[0].s || '';
    document.dispatchEvent(new CustomEvent('wq:main-size', { detail: { size: sel[0].s || '' } }));
    cards.forEach(function (card) {
      var k = +card.dataset.n, on = k === n;
      card.classList.toggle('is-on', on);
      card.querySelector('.fl-b-rows').innerHTML = on ? rowsHtml(k) : '';
      var p = calc(k);
      card.querySelector('[data-p]').textContent = money(p.price);
      var cmp = card.querySelector('[data-cmp]'); if (cmp) cmp.textContent = p.price < p.sum ? money(p.sum) : '';
      var sv = card.querySelector('[data-save]'); if (sv && p.t > 1) sv.textContent = 'Save ' + Math.round((p.sum - p.price) / p.sum * 100) + '%';
      var perk = card.querySelector('.fl-b-perk'); if (perk) perk.textContent = '3 or more items · + Free Standard shipping';
    });
    var main = document.querySelector('.wq-pdp-price'), selectedRow = sel[0], mainVariant = selectedRow.s ? find(selectedRow.p, selectedRow.c, selectedRow.s) : null;
    if (main && selectedRow.p === CUR) {
      var original = mainVariant ? mainVariant.price : CUR._base, unit = PRICING.unitPrice(original, {vendor: VENDOR, type: 'Graphic Apparel'}, false), compare = Math.max(original, mainVariant && mainVariant.compare_at_price || 0);
      main.querySelector('b').textContent = money(unit);
      var strike = main.querySelector('s'); if (compare > unit) { if (!strike) { strike = document.createElement('s'); main.appendChild(strike); } strike.textContent = money(compare); } else if (strike) strike.remove();
      main.classList.toggle('is-sale', compare > unit);
    }
    var compareCopy = box.querySelector('[data-wq-club-compare-text]');
    if (compareCopy) {
      var memberQuote = calc(n, true);
      compareCopy.textContent = 'Club members pay ' + money(memberQuote.price) + ' for ' + (memberQuote.t === 1 ? 'this ' + noun : 'these ' + memberQuote.t + ' ' + nounPlural) + '.';
    }
    var t = calc(n);
    var clubCharge = window.WQClub ? WQClub.charge() : 0;
    btn.textContent = clubCharge ? 'Add ' + t.t + (t.t === 1 ? ' ' + noun : ' ' + nounPlural) + ' + Club to cart · ' + money(t.price + clubCharge) : 'Add to cart · ' + money(t.price);
    if (busy()) btn.textContent = 'Loading your picks…';
    syncPT(t.price + clubCharge);
    save();
  }

  /* ---------- payment terms (Shop Pay installments) ---------- */
  var ptMeta = null, ptLast = null;
  function pm(s) { return s ? parseFloat(String(s).replace(/[^0-9.]/g, '')) : NaN; }
  function syncPT(cents) {
    var el = box.querySelector('.fl-pt shopify-payment-terms'); if (!el) return;
    if (!ptMeta) { var raw = el.getAttribute('shopify-meta'); if (!raw) return; try { ptMeta = JSON.parse(raw); } catch (e) { return; } }
    if (ptLast === cents) return; ptLast = cents;
    var m = JSON.parse(JSON.stringify(ptMeta)), tot = cents / 100, mn = pm(m.min_price), mx = pm(m.max_price);
    var ok = (isNaN(mn) || tot >= mn) && (isNaN(mx) || tot <= mx);
    (m.variants || []).forEach(function (v) {
      var nt = v.number_of_payment_terms || v.numberOfPaymentTerms || 4;
      Object.keys(v).forEach(function (key) {
        var lk = key.toLowerCase(), val = v[key];
        if (lk.indexOf('eligible') > -1) { v[key] = ok; return; }
        if (lk.indexOf('price') < 0) return;
        var amt = lk.indexOf('term') > -1 ? tot / nt : tot;
        if (typeof val === 'string') v[key] = '$' + amt.toFixed(2);
        else if (typeof val === 'number') v[key] = val >= 1000 ? Math.round(amt * 100) : Math.round(amt * 100) / 100;
      });
    });
    var nw = document.createElement('shopify-payment-terms');
    Array.prototype.forEach.call(el.attributes, function (a) { if (a.name !== 'data-instance-id' && a.name !== 'shopify-meta') nw.setAttribute(a.name, a.value); });
    nw.setAttribute('shopify-meta', JSON.stringify(m));
    el.replaceWith(nw);
  }
  function syncGallery(c) {
    var gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      var images = Array.from(gallery.querySelectorAll('img'));
      var image = images.find(function (im) { return (im.alt || '').toLowerCase().indexOf('in ' + c.toLowerCase()) >= 0; }) || images.find(function (im) { return decodeURIComponent(im.src).toLowerCase().indexOf(c.toLowerCase()) >= 0; });
      if (image) gallery.scrollTo({ left: image.parentElement.offsetLeft - gallery.firstElementChild.offsetLeft, behavior: 'smooth' });
    }
    var vp = document.querySelector('variant-picker'); if (!vp) return;
    var el = vp.querySelector('[data-option-name=Color] input[value="' + c + '"]');
    if (el && !el.checked) el.click();
  }

  /* ---------- events ---------- */
  function busy() { return box.classList.contains('fl-b--loading'); }
  box.addEventListener('click', function (e) {
    if (busy()) { e.preventDefault(); return; }
    if (e.target.closest('[data-sg]')) { openSizeGuide(); return; }
    var zb = e.target.closest('[data-zoom]');
    if (zb) { openZoomRow(+zb.dataset.zoom); return; }
    var swap = e.target.closest('[data-swap]');
    if (swap) { openPicker(+swap.dataset.swap); return; }
    if (e.target.closest('.fl-more')) {
      if (r < MAXROWS) { var last = sel[r - 1]; sel[r] = { p: last.p, c: last.c, s: '' }; r++; render(); }
      return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm) { removeRow(+rm.dataset.rm); return; }
    if (e.target.closest('select, label, .fl-pt')) return;
    var card = e.target.closest('.fl-b-card');
    if (card) { var k = +card.dataset.n; if (k !== n) { n = k; render(); } }
  });
  box.addEventListener('keydown', function (e) {
    var swap = e.target.closest('[data-swap]');
    if (!swap || swap.tagName === 'BUTTON' || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    if (!busy()) openPicker(+swap.dataset.swap);
  });
  box.addEventListener('change', function (e) {
    if (busy()) { render(); return; }
    var t = e.target;
    if (t.dataset.size != null) { sel[+t.dataset.size].s = t.value; render(); return; }
    if (t.dataset.color != null) {
      var i = +t.dataset.color; sel[i].c = t.value;
      if (i === 0 && sel[0].p === CUR) syncGallery(sel[0].c);
      render();
    }
  });

  btn.addEventListener('click', function () {
    if (busy()) return;
    var t = rows(n), items = [];
    for (var i = 0; i < t; i++) {
      if (!sel[i].s) {
        tried = true; render();
        var bad = box.querySelector('.fl-err');
        if (bad) { bad.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        btn.textContent = t > 1 ? 'Choose a size for each tee' : 'Choose a size';
        return;
      }
      var v = find(sel[i].p, sel[i].c, sel[i].s);
      if (!v || !v.available) {
        tried = true; render();
        btn.textContent = 'Choose a valid color and size for each tee';
        return;
      }
      items.push(v.id);
    }
    if (!items.length) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var addition = window.WQClub ? WQClub.addTees(items, WQClub.selected()) : fetch(ROOT + 'cart.js', { headers: H, cache: 'no-store' }).then(function (res) { return res.json(); }).then(function (cart) {
      var hasFull = (cart.items || []).some(function (it) { return it.vendor === VENDOR && it.requires_shipping === true && it.product_type === 'Graphic Apparel' && it.properties && it.properties._fl_role === 'full'; });
      var grouped = {}, order = [];
      items.forEach(function (id) {
        var role = hasFull ? 'additional' : 'full'; hasFull = true;
        var k = id + '|' + role;
        if (!grouped[k]) { grouped[k] = { id: id, quantity: 0, properties: { _fl_role: role } }; order.push(k); }
        grouped[k].quantity++;
      });
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: order.map(function (k) { return grouped[k]; }) }) });
    });
    addition.then(function (res) {
      if (res.ok === false) throw new Error('add');
      btn.disabled = false; tried = false; render();
      if (document.querySelector('[data-light-drawer]') || document.querySelector('m-cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true, addedVariantId: items[0] } }));
      else location.href = ROOT + 'cart';
    }).catch(function () {
      btn.disabled = false; render();
      btn.textContent = 'Something went wrong. Please try again.';
    });
  });

  /* ---------- design picker ---------- */
  var modal = null, target = 0, chip = 'All', query = '';
  function scoreFor(p, base) {
    var bt = (base.tags || []).filter(function (t) { return !GENERIC[String(t).toLowerCase()]; });
    return (p.tags || []).filter(function (t) { return bt.indexOf(t) > -1; }).length;
  }
  function itemHtml(p) {
    var u = p.images && p.images[0] ? p.images[0].src : '';
    var price = p.variants && p.variants[0] ? '$' + p.variants[0].price : '';
    return '<li class="fl-pk-li"><button type="button" class="fl-pk-zoom" data-pzoom="' + esc(p.handle) + '" aria-label="View ' + esc(p.title) + ' larger">' +
      '<img src="' + esc(img(u, 160)) + '" alt="" width="64" height="64" loading="lazy">' +
      '<span class="fl-zm-ic" aria-hidden="true">' + ZOOM_SVG + '</span></button>' +
      '<button type="button" class="fl-pk-item" data-pick="' + esc(p.handle) + '">' +
      '<span class="fl-pk-t">' + esc(p.title) + '<small>' + esc(price) + '</small></span>' +
      '<span class="fl-pk-btn">Select</span></button></li>';
  }
  function drawList() {
    if (!modal) return;
    var body = modal.querySelector('.fl-pk-body');
    if (!list) { body.innerHTML = '<p class="fl-pk-msg">Loading designs…</p>'; return; }
    var base = sel[target].p, q = query.trim().toLowerCase();
    var items = list.filter(function (p) {
      if (chip !== 'All' && (p.tags || []).indexOf(chip) < 0) return false;
      if (q && (p.title + ' ' + (p.tags || []).join(' ')).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
    var h = '';
    if (!q && chip === 'All') {
      var pairs = list.filter(function (p) { return p.handle !== base.handle && scoreFor(p, base) > 0; })
        .sort(function (a, b) { return scoreFor(b, base) - scoreFor(a, base); }).slice(0, 6);
      if (pairs.length) h += '<p class="fl-pk-sub">Pairs well with ' + esc(base.title) + '</p><ul class="fl-pk-list">' + pairs.map(itemHtml).join('') + '</ul><p class="fl-pk-sub">All designs</p>';
    }
    h += items.length ? '<ul class="fl-pk-list">' + items.map(itemHtml).join('') + '</ul>' : '<p class="fl-pk-msg">No designs found. Try another word.</p>';
    body.innerHTML = h;
  }
  function pickDesign(handle, it) {
    if (it) it.classList.add('is-loading');
    return loadProduct(handle).then(function (p) {
      var row = sel[target];
      var c2 = p._colors.indexOf(row.c) > -1 ? row.c : p._colors[0];
      var s2 = row.s && find(p, c2, row.s) ? row.s : '';
      sel[target] = { p: p, c: c2, s: s2 };
      if (String(row.p.id) !== String(p.id)) {
        try {
          var changedEvent = Shopify.analytics.publish('fl_bundle_design_changed', { tee: target + 1, from_product_id: row.p.id, to_product_id: p.id });
          if (changedEvent && changedEvent.catch) changedEvent.catch(function () {});
        } catch (e) {}
      }
      closePicker(); render();
      return true;
    }).catch(function () { if (it) it.classList.remove('is-loading'); return false; });
  }
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'fl-pk';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Choose a design');
    modal.innerHTML = '<div class="fl-pk-panel"><div class="fl-pk-hd"><p class="fl-pk-h">Choose a design</p><button type="button" class="fl-pk-x" aria-label="Close">×</button></div>' +
      '<div class="fl-pk-tools"><input type="search" class="fl-pk-q" placeholder="Search designs…" aria-label="Search designs"><div class="fl-pk-chips"></div></div>' +
      '<div class="fl-pk-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.fl-pk-x')) { closePicker(); return; }
      var c = e.target.closest('[data-chip]'); if (c) { chip = c.dataset.chip; drawChips(); drawList(); return; }
      var pz = e.target.closest('[data-pzoom]');
      if (pz) { openZoomPick(pz.dataset.pzoom); return; }
      var it = e.target.closest('[data-pick]');
      if (it) pickDesign(it.dataset.pick, it);
    });
    modal.querySelector('.fl-pk-q').addEventListener('input', function (e) { query = e.target.value; drawList(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open') && !zoomOpen()) closePicker(); });
  }
  function drawChips() {
    var present = CHIPS.filter(function (t) { return !list || list.some(function (p) { return (p.tags || []).indexOf(t) > -1; }); });
    modal.querySelector('.fl-pk-chips').innerHTML = ['All'].concat(present).map(function (t) {
      return '<button type="button" data-chip="' + esc(t) + '"' + (t === chip ? ' class="on" aria-pressed="true"' : ' aria-pressed="false"') + '>' + esc(t) + '</button>';
    }).join('');
  }
  var lastFocus = null;
  function openPicker(i) {
    try {
      var openEvent = Shopify.analytics.publish('fl_bundle_picker_open', { tee: i + 1, product_id: sel[i].p.id });
      if (openEvent && openEvent.catch) openEvent.catch(function () {});
    } catch (e) {}
    target = i; chip = 'All'; query = '';
    if (!modal) buildModal();
    modal.querySelector('.fl-pk-q').value = '';
    lastFocus = document.activeElement;
    modal.classList.add('is-open'); document.documentElement.classList.add('fl-pk-lock');
    drawChips(); drawList();
    modal.querySelector('.fl-pk-body').scrollTop = 0;
    loadList().then(function () { drawChips(); drawList(); }).catch(function () {
      modal.querySelector('.fl-pk-body').innerHTML = '<p class="fl-pk-msg">Could not load designs. Please try again.</p>';
    });
    setTimeout(function () { var x = modal.querySelector('.fl-pk-x'); if (x) x.focus(); }, 30);
  }
  function closePicker() {
    modal.classList.remove('is-open');
    if (!zoomOpen()) document.documentElement.classList.remove('fl-pk-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function pickerOpen() { return !!(modal && modal.classList.contains('is-open')); }

  /* ---------- larger design view (v3.8) ---------- */
  var zm = null, zmMode = '', zmRow = 0, zmHandle = '', zmImgs = [], zmIdx = 0, zmFocus = null;
  function zoomOpen() { return !!(zm && zm.classList.contains('is-open')); }
  function srcOf(x) { return x && typeof x === 'object' ? (x.src || '') : (x || ''); }
  function uniq(a) { var o = []; a.forEach(function (u) { if (u && o.indexOf(u) < 0) o.push(u); }); return o; }
  function buildZoom() {
    zm = document.createElement('div');
    zm.className = 'fl-zm';
    zm.setAttribute('role', 'dialog'); zm.setAttribute('aria-modal', 'true'); zm.setAttribute('aria-label', 'Design preview');
    zm.innerHTML = '<div class="fl-zm-panel"><button type="button" class="fl-zm-x" aria-label="Close">×</button>' +
      '<div class="fl-zm-stage"><img class="fl-zm-img" alt="">' +
      '<button type="button" class="fl-zm-nav fl-zm-prev" aria-label="Previous image">‹</button>' +
      '<button type="button" class="fl-zm-nav fl-zm-next" aria-label="Next image">›</button>' +
      '<span class="fl-zm-count" aria-hidden="true"></span></div>' +
      '<div class="fl-zm-info"><p class="fl-zm-t"></p><p class="fl-zm-sub"></p><div class="fl-zm-act"></div></div></div>';
    document.body.appendChild(zm);
    zm.addEventListener('click', function (e) {
      if (e.target === zm || e.target.closest('.fl-zm-x') || e.target.closest('[data-zm-close]')) { closeZoom(); return; }
      if (e.target.closest('.fl-zm-prev')) { stepZoom(-1); return; }
      if (e.target.closest('.fl-zm-next')) { stepZoom(1); return; }
      if (e.target.closest('[data-zm-swap]')) { var i = zmRow; closeZoom(true); openPicker(i); return; }
      var pk = e.target.closest('[data-zm-pick]');
      if (pk) {
        pk.disabled = true; pk.textContent = 'Selecting…';
        pickDesign(zmHandle, null).then(function (ok) {
          if (ok) { closeZoom(true); return; }
          pk.disabled = false; pk.textContent = 'Select this design';
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!zoomOpen()) return;
      if (e.key === 'Escape') { e.stopPropagation(); closeZoom(); }
      else if (e.key === 'ArrowLeft') stepZoom(-1);
      else if (e.key === 'ArrowRight') stepZoom(1);
    }, true);
    var stage = zm.querySelector('.fl-zm-stage'), sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) stepZoom(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function drawZoom() {
    var im = zm.querySelector('.fl-zm-img'), many = zmImgs.length > 1;
    im.src = img(zmImgs[zmIdx], 1200);
    zm.querySelector('.fl-zm-prev').hidden = !many;
    zm.querySelector('.fl-zm-next').hidden = !many;
    var cnt = zm.querySelector('.fl-zm-count');
    cnt.hidden = !many; cnt.textContent = many ? (zmIdx + 1) + ' / ' + zmImgs.length : '';
  }
  function stepZoom(d) {
    if (zmImgs.length < 2) return;
    zmIdx = (zmIdx + d + zmImgs.length) % zmImgs.length;
    drawZoom();
  }
  function showZoom(title, sub, actions, productId) {
    if (!zm) buildZoom();
    zmIdx = 0;
    zm.querySelector('.fl-zm-t').textContent = title;
    zm.querySelector('.fl-zm-sub').textContent = sub;
    zm.querySelector('.fl-zm-act').innerHTML = actions;
    drawZoom();
    zmFocus = document.activeElement;
    zm.classList.add('is-open'); document.documentElement.classList.add('fl-pk-lock');
    setTimeout(function () { var x = zm.querySelector('.fl-zm-x'); if (x) x.focus(); }, 30);
    try {
      var zoomEvent = Shopify.analytics.publish('fl_bundle_zoom_open', { source: zmMode, product_id: productId });
      if (zoomEvent && zoomEvent.catch) zoomEvent.catch(function () {});
    } catch (e) {}
  }
  function closeZoom(skipFocus) {
    if (!zm) return;
    zm.classList.remove('is-open');
    if (!pickerOpen()) document.documentElement.classList.remove('fl-pk-lock');
    if (!skipFocus && zmFocus && zmFocus.focus) zmFocus.focus();
  }
  function openZoomRow(i) {
    var row = sel[i]; if (!row) return;
    var v = anyOfColor(row.p, row.c);
    zmMode = 'row'; zmRow = i;
    zmImgs = uniq([srcOf((v && v.featured_image) || row.p.featured_image || row.p.image)]);
    var acts = '<button type="button" class="fl-zm-btn fl-zm-btn--rust" data-zm-swap><span aria-hidden="true">↻</span> ' + esc(swapLabel) + '</button>' +
        '<button type="button" class="fl-zm-btn" data-zm-close>Looks good</button>';
    showZoom(row.p.title, 'Color: ' + row.c, acts, row.p.id);
  }
  function openZoomPick(handle) {
    var p = (list || []).find(function (x) { return x.handle === handle; }); if (!p) return;
    var c = sel[target] && sel[target].c, first = '';
    (p.variants || []).some(function (v) {
      if (v.featured_image && (v.option1 === c || v.option2 === c || v.option3 === c)) { first = srcOf(v.featured_image); return true; }
      return false;
    });
    zmMode = 'picker'; zmHandle = handle;
    zmImgs = uniq([first].concat((p.images || []).map(srcOf)));
    if (!zmImgs.length) return;
    var price = p.variants && p.variants[0] ? '$' + p.variants[0].price : '';
    showZoom(p.title, price,
      '<button type="button" class="fl-zm-btn fl-zm-btn--ghost" data-zm-close>Back</button>' +
      '<button type="button" class="fl-zm-btn" data-zm-pick>Select this design</button>', p.id);
  }

  document.addEventListener('wq:club-change', render);
  var bar = box.querySelector('.fl-b-bar');
  if (bar && Date.now() > Date.UTC(2026, 11, 12, 5)) bar.remove();
  document.body.classList.add('fl-on');
  /* While restoring saved picks, lock the bundle so nothing can be added or changed
     until product, color, size and price are back in sync. Normal visits skip this. */
  var restoring = !!(saved && saved.rows);
  if (restoring) { box.classList.add('fl-b--loading'); box.setAttribute('aria-busy', 'true'); }
  render();
  if (restoring) { btn.disabled = true; btn.textContent = 'Loading your picks…'; }
  function unlock(ok) {
    if (unlocked) return;
    unlocked = true; ready = true;
    if (ok && sel[0].p === CUR) syncGallery(sel[0].c);
    box.classList.remove('fl-b--loading'); box.removeAttribute('aria-busy');
    btn.disabled = false;
    render();
  }
  restore().then(unlock, function () { unlock(false); });
  if (restoring) setTimeout(function () { unlock(false); }, 4000);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { btn.disabled = false; render(); } });
  loadList().catch(function () {});
})();
